export default "__VITE_ASSET__CDDTB929__"